module.exports = __webpack_public_path__ + "img/philosophy_treatment.923c4636.jpg";